import React, { useRef, useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import Product from "../products/Product";
import VariationProduct from './VariationProduct';
import { Toast } from 'primereact/toast';
import { getProductActiveVariations } from './../../../apis/requests';
import PropTypes from 'prop-types';
const ProductVariations = (props) => {
    const { t } = useTranslation();
    const carouselRef = useRef();
    const [variations, setVariations] = useState([]);
    const [defaultVariation, setDefaultVariation] = useState();
    const storeFrontData = useSelector((state) => state.app.storeData);
    const products = storeFrontData.latestProducts;
    const { pid, vid, name } = props.prod;
    const toast = useRef();
    const responsive = {
        tv: {
            breakpoint: { max: 3000, min: 1700 },
            items: 7,
            slidesToSlide: 1
        },
        desktop: {
            breakpoint: { max: 1700, min: 960 },
            items: 5,//6
            slidesToSlide: 2
        },
        tablet: {
            breakpoint: { max: 959, min: 760 },
            items: 3,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 760, min: 0 },
            items: 2,
            slidesToSlide: 1
        }
    };
    useEffect(() => {
        loadGetProductActiveVariations();
    }, []);
    const loadGetProductActiveVariations = async () => {
        try {
            let params = {
                id: pid
            };
            const res = await getProductActiveVariations(params);
            setVariations(res.data.productVariations.filter((v) => v.variation.id !== vid));
            props.onLoad(res.data.productVariations.find((v) => v.variation.id === vid));
        } catch (error) {
            console.log(error);

        }
    }
    return (
        <div>
            <Toast ref={toast}
                position="bottom-center"
            />

            <div>
                <h1 className="font-bold mx-4 text-xl mb-2">{name}</h1>
                <p className="mx-4 font-semibold">is also is_also_available_in_diffrent styles and sizes..</p>
            </div>

            <div className="lg:mx-8">
                <Carousel
                    ref={carouselRef}
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    responsive={responsive}
                    ssr={true}
                    infinite={true}
                    autoPlay={false}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["mobile", "desktop", "tablet", "tv"]}

                >
                    {
                        variations.map((item) => {
                            return (
                                <div key={item.id}>
                                    <VariationProduct item={item}
                                        showToast={() => {
                                            toast.current.show({ severity: 'success', detail: t('item_added_to_cart'), life: 3000 });
                                        }}
                                    />
                                </div>

                            );
                        })
                    }

                </Carousel>
            </div>
            <div className="flex items-center content-center mb-4 mt-3"
                style={{
                    direction: "initial"
                }}
            >
                <div className="mx-3">
                    <Button outlined rounded severity="secondary" icon={<span className="material-symbols-outlined">arrow_left_alt</span>}
                        onClick={() => {
                            carouselRef.current.previous();
                        }}
                    />
                </div>
                <div className="mx-3">
                    <Button outlined rounded severity="secondary" icon={<span className="material-symbols-outlined">arrow_right_alt</span>}
                        onClick={() => {
                            carouselRef.current.next();
                        }}
                    />
                </div>
            </div>
        </div>

    );
}
ProductVariations.propTypes = {
    prod: PropTypes.object.isRequired,
    onLoad: PropTypes.func.isRequired
};
export default ProductVariations;